import React from "react";

interface TableSkeletonProps {
    columns: string[]; // Array of column labels
    rows?: number;
}

const TableSkeleton: React.FC<TableSkeletonProps> = ({ columns, rows = 6 }) => {
    return (
        <div className="overflow-auto bg-[#FCFDF8] rounded-tl-none rounded-3xl ">
            <table className="w-full text-sm">
                <thead className="text-[#131327]/70 border-b border-dashed">
                    <tr>
                        {columns?.map((label, idx) => (
                            <th
                                key={idx}
                                className="text-left font-semibold px-6 py-5"
                            >
                                {label}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {Array.from({ length: rows }).map((_, rowIdx) => (
                        <tr key={rowIdx} className="animate-pulse group cursor-default">
                            {columns?.map((_, colIdx) => (
                                <td
                                    key={colIdx}
                                    className={`px-6 py-5 ${
                                        colIdx === 0
                                        ? "rounded-l-3xl"
                                        : colIdx === columns.length - 1
                                        ? "rounded-r-3xl"
                                        : ""
                                    }`}
                                >
                                    <div className="h-4 w-full bg-gray-200 rounded" />
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default TableSkeleton;
